import React from 'react';
import type { MediaItemValue } from '@fulcrumapp/fulcrum-core';
import SketchMetadataView from '../sketch-metadata-view';
import type { MediaDisplayer, Metadata } from './media-displayer';
import MediaThumbnail from './media-thumbnail';
import configuredPhotoView from './configured-photo-view';

const sketchDisplayer: MediaDisplayer = {
  display: configuredPhotoView,
  thumbnail(
    item: MediaItemValue,
    onClick: (item: MediaItemValue) => void,
    extraStyles: React.CSSProperties,
  ): React.ReactElement {
    return (
      <MediaThumbnail
        item={item}
        styles={extraStyles}
        handleClick={() => onClick(item)}
        data-testid="sketch-thumbnail"
      />
    );
  },
  // Sketches do not have or need a map view
  mapView(
    item: MediaItemValue,
    metadata: Metadata,
    cssClass: string,
    feature: any,
    showLabels: boolean,
    _trackInfo?: any,
    _useEsriMap?: boolean,
  ): React.ReactElement {
    return <></>;
  },
  metadata(item: MediaItemValue, metadata: Metadata, cssClass: string): React.ReactElement {
    return (
      <SketchMetadataView
        className={cssClass}
        metadata={metadata}
      />
    );
  },
};

export default sketchDisplayer;
